export const cilUnderline = ["24 24","<path d='M0.75 0.75v22.5h22.5v-22.5zM21.75 21.75h-19.5v-19.5h19.5z'></path><path d='M7.875 11.25c0 2.485 2.015 4.5 4.5 4.5s4.5-2.015 4.5-4.5v0-4.125h1.5v-1.5h-4.5v1.5h1.5v4.125c0 0 0 0.001 0 0.002 0 1.656-1.342 2.998-2.998 2.998-0.406 0-0.793-0.081-1.146-0.227l0.020 0.007v-6.905h1.125v-1.5h-6v1.5h1.5z'></path><path d='M6.375 17.25h12v1.5h-12v-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-underline.js
// module id = null
// module chunks = 